import {
  take,
  put,
  call,
  all,
  takeLatest,
  takeEvery,
} from 'redux-saga/effects';
import { attendanceDashboardActions as actions, notificationActions } from '../actions';
import { attendanceDashboardService } from '../services';


// Check In Check Out sagas
function* handleCheckInCheckOutRequest() {
  const action = yield take(actions.checkInCheckOutRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(attendanceDashboardService.chackInCheckOut, dataParams);
    if (res.isError) {
      yield put(actions.checkInCheckOutError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.checkInCheckOutSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.checkInCheckOutError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

//get Check In Check Out sagas
function* handleGetCheckInCheckOutRequest() {
  const action = yield take(actions.getCheckInCheckOutRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(attendanceDashboardService.getChackInCheckOut, dataParams);
    if (res.isError) {
      yield put(actions.getCheckInCheckOutError(res));
      // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage , alertType: 'error' }));
    } else {
      yield put(actions.getCheckInCheckOutSuccess(res));
      // yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.errorMessage , alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.getCheckInCheckOutError());
    // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage , alertType: 'error' }));
  }
}

//get Attendance Summary
function* handleGetAttendanceSummaryRequest() {
  const action = yield take(actions.getAttendanceSummaryRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(attendanceDashboardService.getAttendanceSummary, dataParams);
    if (res.isError) {
      yield put(actions.getAttendanceSummaryError(res));
    } else {
      yield put(actions.getAttendanceSummarySuccess(res));
    }
  } catch (error) {
    yield put(actions.getAttendanceSummaryError());
  }
}

//get Attendance Summary
function* handleGetMonthlyAttendanceRequest() {
  const action = yield take(actions.getMonthlyAttendanceRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(attendanceDashboardService.getMonthlyAttendance, dataParams);
    if (res.isError) {
      yield put(actions.getMonthlyAttendanceError(res));
    } else {
      yield put(actions.getMonthlyAttendanceSuccess(res));
    }
  } catch (error) {
    yield put(actions.getMonthlyAttendanceError());
  }
}

//get Attendance DashBoard
function* handleGetAttendanceDashBoardRequest() {
  const action = yield take(actions.getAttendanceDashBoardRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(attendanceDashboardService.getAttendanceDashboard, dataParams);
    if (res.isError) {
      yield put(actions.getAttendanceDashBoardError(res));
    } else {
      yield put(actions.getAttendanceDashBoardSuccess(res));
    }
  } catch (error) {
    yield put(actions.getAttendanceDashBoardError());
  }
}

//Get Correction Notification
function* handleGetCorrectionNotificationRequest() {
  const action = yield take(actions.getCorrectionNotificationRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(attendanceDashboardService.getCorrectionNotification, dataParams);
    if (res.isError) {
      yield put(actions.getCorrectionNotificationError(res));
    } else {
      yield put(actions.getCorrectionNotificationSuccess(res));
    }
  } catch (error) {
    yield put(actions.getCorrectionNotificationError());
  }
}

/* Attendance Lock */
function* handleAttendanceLockRequest() {
  const action = yield take(actions.attendanceLockRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(attendanceDashboardService.attendanceLock, dataParams);
    if (res.isError) {
      yield put(actions.attendanceLockError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.attendanceLockSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.attendanceLockError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*Get Attendance Lock */
function* handleGetAttendanceLockRequest() {
  const action = yield take(actions.getAttendanceLockRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(attendanceDashboardService.getAttendanceLock, dataParams);
    if (res.isError) {
      yield put(actions.getAttendanceLockError(res));
    } else {
      yield put(actions.getAttendanceLockSuccess(res));
    }
  } catch (error) {
    yield put(actions.getAttendanceLockError());
  }
}

/*Get Attendance Lock */
function* handleUpdateAttendanceLockRequest() {
  const action = yield take(actions.updateAttendanceLockRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(attendanceDashboardService.updateAttendanceLock, dataParams);
    if (res.isError) {
      yield put(actions.updateAttendanceLockError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateAttendanceLockSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.updateAttendanceLockError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

// -----------Watchers-------------
function* handleCheckInCheckOutWatcher() {
  yield takeEvery(
    actions.checkInCheckOutRequest,
    handleCheckInCheckOutRequest,
  );
}
function* handleGetCheckInCheckOutWatcher() {
  yield takeEvery(
    actions.getCheckInCheckOutRequest,
    handleGetCheckInCheckOutRequest,
  );
}

function* handleGetAttendanceSummaryWatcher() {
  yield takeEvery(
    actions.getAttendanceSummaryRequest,
    handleGetAttendanceSummaryRequest,
  );
}

function* handleGetMonthlyAttendanceWatcher() {
  yield takeEvery(
    actions.getMonthlyAttendanceRequest,
    handleGetMonthlyAttendanceRequest,
  );
}

function* handleGetAttendanceDashBoardWatcher() {
  yield takeEvery(
    actions.getAttendanceDashBoardRequest,
    handleGetAttendanceDashBoardRequest,
  );
}

function* handleGetCorrectionNotificationWatcher() {
  yield takeEvery(
    actions.getCorrectionNotificationRequest,
    handleGetCorrectionNotificationRequest,
  );
}


function* handleAttendanceLockWatcher() {
  yield takeEvery(
    actions.attendanceLockRequest,
    handleAttendanceLockRequest,
  );
}

function* handleGetAttendanceLockWatcher() {
  yield takeEvery(
    actions.getAttendanceLockRequest,
    handleGetAttendanceLockRequest,
  );
}

function* handleUpdateAttendanceLockWatcher() {
  yield takeEvery(
    actions.updateAttendanceLockRequest,
    handleUpdateAttendanceLockRequest,
  );
}



function* rootattendanceDashboardSaga() {
  yield all([
    handleCheckInCheckOutRequest(),
    handleCheckInCheckOutWatcher(),

    handleGetCheckInCheckOutRequest(),
    handleGetCheckInCheckOutWatcher(),

    handleGetAttendanceSummaryRequest(),
    handleGetAttendanceSummaryWatcher(),

    handleGetMonthlyAttendanceRequest(),
    handleGetMonthlyAttendanceWatcher(),

    handleGetAttendanceDashBoardRequest(),
    handleGetAttendanceDashBoardWatcher(),

    handleGetCorrectionNotificationRequest(),
    handleGetCorrectionNotificationWatcher(),

    handleAttendanceLockRequest(),
    handleAttendanceLockWatcher(),
 
    handleGetAttendanceLockRequest(),
    handleGetAttendanceLockWatcher(),
     
    handleUpdateAttendanceLockRequest(),
    handleUpdateAttendanceLockWatcher(),

  ]);
}

export default rootattendanceDashboardSaga;
